import { ApiNoteStatus } from 'api/rtk-api'

export const noteStatusTabMapper = (status: ApiNoteStatus) => {
  switch (status) {
    case 'PendingApproval': {
      return 'approve'
    }
    case 'PendingCommitment':
    case 'PendingClientCommitment': {
      return 'commitment'
    }
    case 'PendingSettlement': {
      return 'settlement'
    }
    case 'PendingActivation': {
      return 'activate'
    }
    default: {
      return 'approve'
    }
  }
}
